// 用户详情
import React, { useState, useEffect } from 'react'
import ScrollLoader from 'Components/scroll-loader'
import get from 'lodash/get'
import fetch from 'lib/decorated-fetch'
import Head from 'next/head'

import getUrl from 'lib/url'
import applyHttpsImage from 'lib/apply-https-img'
import { sendTeaCommEvent } from 'lib/tea-analyze'

import Article from 'Components/article'
import Loading from 'Components/loading'
import Breadcrumb from 'Components/breadcrumb'
import FooterStatement from 'Components/footer-statement'

interface IProps {
  groupData: {
    sections: []
    section_id: number
    section_name: string
  }
}

function Group({
  groupData = { sections: [], section_id: 0, section_name: '' },
}: IProps) {
  const [loading, setLoading] = useState(false)

  const sectionName = get(groupData, 'section_name', '')
  const authorName = get(groupData, 'author_name', '-')
  return (
    <div className="group-wrapper">
      <Head>
        <title key="title">{sectionName} - 懂车帝</title>
        <meta
          key="keywords"
          name="keywords"
          content={`懂车帝视频栏目,${sectionName},${authorName}`}
        />
        <meta
          key="description"
          name="description"
          content={`懂车帝${sectionName}视频栏目,栏目作者为${authorName},栏目包含作者已发布过的文章和视频`}
        />
      </Head>
      <Breadcrumb
        path={[
          { name: '视频', href: '/video/home', as: '/video' },
          {
            name: '懂车帝原创',
            href: '/video/groups-origin',
            as: '/video/groups-origin',
          },
          { name: sectionName },
        ]}
      />
      <section className="group-header">
        <div className="cover" />
        <div className="userinfo-wrapper">
          <h1 className="group-name">{get(groupData, 'section_name', '-')}</h1>
          <div className="user-wrapper">
            <div className="avatar" />
            <p className="user-name">
              {authorName}
              <span>共{get(groupData, 'article_count', 0)}期</span>
            </p>
          </div>
        </div>
        <div className="movie" />
      </section>
      <ScrollLoader
        loading={loading}
        end={false}
        loadMoreHandler={() => {
          console.log('load')
        }}
      >
        <div className="feed-wrapper">
          {groupData['sections']
            ? groupData['sections'].map(
              (item: { [props: string]: string }, index: number) => {
                // const data = {
                //   ...item,
                //   unique_id_str: get(item, 'group_id_str'),
                // }
                return (
                  <Article
                    key={item.group_id_str}
                    isRecommend
                    gid={item.group_id_str}
                    cover={item.thumb_uri}
                    duration={item.video_duration}
                    title={item.title}
                    source={item.author_name}
                    time={((item.create_time as unknown) as number) * 1000}
                    onClick={() => {
                      sendTeaCommEvent('click_column_article', {
                        column_id: groupData.section_id,
                        column_name: groupData.section_name,
                        group_id: item.group_id_str,
                      })
                    }}
                  />
                )
              }
            )
            : null}
        </div>
      </ScrollLoader>
      {loading ? <Loading /> : null}

      <footer>
        <FooterStatement />
      </footer>
      <style jsx>
        {`
          .group-wrapper {
              width: 1190px;
              margin: 10px auto 0;
          }
          .group-header {
              display: flex;
              flex-direction: row;
              background: #1a1a1a;
              align-items: center;
              position: relative;
          }
          .cover {
              width: 344px;
              height: 196px;
              background-image: url('${applyHttpsImage(
      get(groupData, 'cover', '')
    )}');
              background-size: 100%;
              background-color: #e6e6e6;
              margin: 12px 0 12px 12px;
          }
          .group-name {
            font-size: 32px;
            color: #ffffff;
            font-weight: 500;
          }
          .avatar {
            width: 32px;
            height: 32px;
            background-image: url('${applyHttpsImage(
      get(groupData, 'author_avatar', '')
    )}');
            background-size: 100%;
            background-color: #e6e6e6;
            border-radius: 16px;
          }
          .userinfo-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            padding: 0 0 0 40px;
          }
          .user-wrapper {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 16px;
          }
          .user-name {
            font-size: 18px;
            color: #ffffff;
            margin-left: 8px;
          }
          .user-name span {
            margin-left: 16px;
          }
          .movie {
            float: right;
            width: 335px;
            height: 220px;
            background-image: url('${require('static/movie@3x.png')}');
            background-size: 100%;
            position: absolute;
            right: 0;
          }
      `}
      </style>
    </div>
  )
}

Group.getInitialProps = async ({ query, req }: any) => {
  const fetchGroupData = async () => {
    const json = await fetch(
      getUrl(
        `/motor/pleasure/collection/general-info?column_id=${query.groupId}`,
        'motor.pleasure.api'
      ),
      { req }
    ).catch(e => {
      // no-op
    })
    return json?.data
  }

  const data = await Promise.all([fetchGroupData()])

  return {
    groupData: data[0],
  }
}

export default Group
